<template>
  <div class="ybl-table-list" :id="`ybl-table-list-${index}`">
    <!-- <el-table :data="data" ref="table" style="width:100%;" height="100%" :max-height="tableMaxHeight" sum-text="汇总" -->
    <el-table :data="data" ref="ybl-table" style="width:100%;" :class="{'nowrap':$attrs.nowrap}" :key="upKey"
      sum-text="汇总" header-cell-class-name="table-header__cell" cell-class-name="table-row__cell"
      @selection-change="handleSelectionChange" v-bind="$attrs" v-on="$listeners" :max-height="maxHeight">
      <el-table-column type="selection" align="center" width="54" :selectable="selectable" v-if="multiple">
      </el-table-column>
      <slot></slot>
      <div slot="empty">
        <div class="default">
          <img src="../assets/images/tableDefault.png" class="default-img">
          <span class="default-placeholder" v-if="!placeholderHandle">{{placeholder}}</span>
          <span class="default-placeholder" v-else>
            <slot name="placeholderHandle"></slot>
          </span>
        </div>
      </div>
      <template slot="append" v-if="setting">
        <div class="setting" :class="!operate?'noOperate':''" :style="`right:${operateWidth?operateWidth:0}px;`">
          <el-tooltip effect="dark" content="表头设置" placement="top">
            <i class="iconfont icon-xitongshezhixianxing" @click="settingTable"></i>
          </el-tooltip>
        </div>
      </template>
    </el-table>
    <div :id="`yblTablePage-${index}`" class="ybl-table-list__footer" v-show="tableInView">
      <div class="ybl-table-list__summary" v-if="summary">
        <div class="ybl-table-list__summary__label">汇总</div>
        <slot name="summary"></slot>
      </div>
      <div class="ybl-table-list__page" ref="yblListPage" v-if="footer && (total>=10 || (multiple&&total>0))"
        :key="data.length">
        <template v-if="!loading">
          <div class="batch-content">
            <div v-if="multiple" class="batch-content_left">
              <span v-if="!selectedAll">已选择本页{{multipleSelection.length}}条</span>
              <span v-else>已勾选全部{{total}}条</span>
              <template v-if="multipleSelection.length>0">
                <span class="cursor primary-color" @click="toggleSelectAll"
                  v-if="total>multipleSelection.length && total>pageSize && multipleAll">{{selectedAll?'取消勾选':`勾选全部${total}条保单`}}</span>
              </template>
              <el-divider direction="vertical"></el-divider>
              <div class="batch-button">
                <!-- <span class="batch-button_label">批量</span> -->
                <slot name="batchButton"></slot>
              </div>
            </div>
          </div>
          <ybl-pager :total="total" @change="change" :background="false" :current.sync="currentPage" :size="pageSize"
            @size-change="sizeChange" :monitor="$attrs.monitor===undefined || !!$attrs.monitor"
            class="ybl-table-list_pager"></ybl-pager>
        </template>
      </div>
      <div class="paddingEmpty" v-else></div>
    </div>
    <!-- <div class="setting" :class="!operate?'noOperate':''" :style="`right:${operateWidth?operateWidth+12:12}px;`" v-if="setting">
      <el-tooltip effect="dark" content="表头设置" placement="top">
        <i class="iconfont icon-xitongshezhixianxing" @click="settingTable"></i>
      </el-tooltip>
    </div> -->
  </div>
</template>
<script>
import { storage } from '@/utils'
export default {
  name: 'yblTableList',
  props: {
    index: {
      type: Number | String,
      default: () => 0
    },
    sceneIndex: {
      type: Number | String,
      default: () => 0
    },
    data: {
      type: Array,
      default: () => []
    },
    total: {
      type: Number | String,
      default: 0
    },
    change: {
      type: Function,
      default: () => { }
    },
    size: {
      type: Number,
      default: () => 10
    },
    multiple: {
      type: Boolean,
      default: () => false
    },
    setting: {
      type: Boolean,
      default: () => false
    },
    collect: {
      type: Array,
      default: () => []
    },
    summary: {
      type: Boolean,
      default: () => false
    },
    placeholder: {
      type: String,
      default: () => '暂无数据'
    },
    defaultVisible: {
      type: Boolean,
      default: () => false
    },
    defaultBtn: {
      type: Object,
      default: () => { }
    },
    selectable: { // 选择禁用方法
      type: Function,
      default: () => { return true }
    },
    placeholderHandle: { // 是否自定义缺省内容
      type: Boolean,
      default: () => false
    },
    footer: { // 是否显示底部
      type: Boolean,
      default: () => true
    },
    operate: { // 是否有操作栏
      type: Boolean,
      default: () => true
    },
    operateWidth: { // 操作栏宽度
      type: Number,
      default: () => 0
    },
    multipleAll: { // 是否有选择全部
      type: Boolean,
      default: () => false
    },
    current: { // 当前页码
      type: Number,
      default: () => 1
    }
  },
  data () {
    return {
      upKey: 0, // 列表更新
      // current: 1,
      currentPage: this.current || 1,
      pageSize: this.size || 10,
      tableHeight: '',
      tableMaxHeight: 0,
      multipleSelection: [],
      selectedAll: false, // 是否全选
      loading: false,
      tableInView: false,
      maxHeight: 500,
      MIN_HEIGHT: 300
    }
  },
  computed: {
    dataLength () {
      if (this.data) return this.data.length
      return 0
    },
    collapse () {
      return storage.getItem('collapse')
    }
  },
  created () {
  },
  mounted () {
    this.resize()
    let _this = this
    window.addEventListener('resize', _this.resize, false)
    _this.$once('hook:beforeDestroy', () => {
      window.removeEventListener('resize', _this.resize, false)
      const layout = document.querySelector('.layout-page.scroll-page')
      layout && layout.removeEventListener('scroll', _this.scrollEvent, false)
    })
  },
  methods: {
    getDisplayElement (elements) {
      let element = null
      for (let i = 0; i < elements.length; i++) {
        if (elements[i].clientHeight) {
          element = elements[i]
          break
        }
      }
      return element
    },
    getPageLayout () {
      const layouts = document.querySelectorAll('.layout-page.scroll-page')
      if (!layouts || layouts.length === 0) {
        return document.querySelector('.layout-page')
      }
      return this.getDisplayElement(layouts)
    },
    scrollEvent () {
      const { index } = this
      const layout = this.getPageLayout()
      const ele = layout.querySelector(`#ybl-table-list-${index}.ybl-table-list`)

      const inView = this.isInViewPortOfOne(ele, layout)
      this.tableInView = inView
      if (inView) {
        const footer = layout.querySelector(`#yblTablePage-${index}.ybl-table-list__footer`)
        const height = layout.clientHeight - footer.clientHeight
        if (height !== this.maxHeight) {
          this.resize()
        }
      }
    },
    isInViewPortOfOne (el, layout) {
      // viewPortHeight 兼容所有浏览器写法
      const viewPortHeight = (layout && layout.clientHeight) || window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
      const offsetTop = (el && el.offsetTop) || 0
      const scrollTop = (layout && layout.scrollTop) || document.documentElement.scrollTop
      const top = offsetTop - scrollTop
      return top <= viewPortHeight
    },
    resize () {
      const { index } = this
      this.$nextTick(() => {
        const layout = this.getPageLayout()

        if (layout) {
          const element = layout.querySelector(`#yblTablePage-${index}.ybl-table-list__footer`)
          const height = (element && element.clientHeight) || 0

          const tableEle = layout.querySelector(`#ybl-table-list-${index}.ybl-table-list`)
          tableEle && (tableEle.style.paddingBottom = `${height + 5}px`)

          const fixedFooterEle = layout.querySelector(`#ybl-table-list-${index} .el-table__fixed-footer-wrapper`)
          const footerHeight = (fixedFooterEle && fixedFooterEle.clientHeight) || 0

          const summaryEle = layout.querySelector(`#yblTablePage-${index} .ybl-table-list__summary`)
          const summaryHeight = (summaryEle && summaryEle.clientHeight) || 0

          const { top = 0 } = (tableEle && tableEle.getBoundingClientRect()) || {}
          const { top: layoutTop = 0 } = layout.getBoundingClientRect()

          this.tableInView = this.isInViewPortOfOne(tableEle, layout)

          // layout.addEventListener('scroll', this.scrollEvent, false)
          let maxHeight = layout.clientHeight - height - summaryHeight - (top - layoutTop) - footerHeight
          // 处理 页面无 scroll-page的场景
          const layouts = document.querySelectorAll('.layout-page.scroll-page')
          if (!layouts || layouts.length === 0) {
            maxHeight -= 60
          }
          // 特殊处理 底部有操作按钮的页面
          const step = document.querySelector('.step')
          if (step) {
            maxHeight -= (step.clientHeight + 30)
          }
          this.maxHeight = Math.max(maxHeight, this.MIN_HEIGHT)
        } else {
          this.tableInView = true
        }
      })
    },
    clearSelection () {
      this.$refs['ybl-table'].clearSelection()
    },
    // 过滤不可选数据
    filterData () {
      const filterValue = this.$attrs.filterValue || null
      const reserveValue = ['否']
      if (filterValue) {
        return this.data.filter(item => reserveValue.includes(item[filterValue]))
      }
      return this.data
    },
    toggleSelectAll () {
      this.selectedAll = !this.selectedAll
      const data = this.filterData()
      if (this.selectedAll && this.multipleSelection.length < data.length) {
        this.$refs['ybl-table'].toggleAllSelection()
      }
      this.$emit('toggleSelectAll', this.selectedAll)
    },
    toggleAllSelection () {
      this.$refs['ybl-table'].toggleAllSelection()
    },
    getTableHeight (newVal) {
      let height = document.documentElement.clientHeight
      let bottomH = 40 // 距离页面下方高度
      let headH = 60 // 头部高度 60
      let titleH = (document.getElementById('yblPageHead') && document.getElementById('yblPageHead').offsetHeight) || 0 // 标题
      let sceneH = 48 // 场景菜单 48
      let sceneTabsH = (document.getElementById('sceneTabs') && document.getElementById('sceneTabs').childNodes[0].offsetHeight) || 0 // .offsetHeight || 0 // 场景菜单高度
      let formH = (document.getElementById(`yblForm-${newVal || this.index}`) && document.getElementById(`yblForm-${newVal || this.index}`).offsetHeight) || 0 // form表单高度
      let pageH = (document.getElementById(`yblTablePage-${newVal || this.index}`) && document.getElementById(`yblTablePage-${newVal || this.index}`).offsetHeight) || 0 // 分页高度
      let tableHeadH = document.getElementsByClassName('el-table__header-wrapper')[0].offsetHeight || 0 // 表格头部高度
      this.tableHeight = height - bottomH - headH - titleH - sceneH - sceneTabsH - formH - pageH - tableHeadH
      this.tableMaxHeight = height - bottomH - headH - titleH - sceneH - sceneTabsH - formH - pageH
      // document.getElementsByClassName('el-table__body-wrapper')[0].style.height = `${this.tableHeight}px`
      document.getElementById(`ybl-table-list-${newVal || this.index}`).children[0].children[2].style.height = `${this.tableHeight}px`
      console.log('index--------', this.index)
    },
    getSummaries (param) {
      let { columns, data } = param
      let sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '汇总'
          return
        }
        let values = data.map(item => Number(item[column.property]))
        if (this.collect.includes(column.property)) {
          sums[index] = values.reduce((prev, curr) => {
            let value = Number(curr)
            if (!isNaN(value)) {
              return prev + curr
            } else {
              return prev
            }
          }, 0)
        }
      })
      return sums
    },
    handleSelectionChange (val) {
      this.multipleSelection = val
      const data = this.filterData()
      if (this.selectedAll && val.length < data.length) {
        this.selectedAll = false
      }
      this.$emit('selection-change', val)
    },
    sizeChange (item) {
      this.pageSize = item.size
      this.$emit('size-change', item)
    },
    settingTable () {
      this.$emit('settingTable')
    },
    toggleRowSelection (rows) {
      this.$nextTick(() => {
        if (rows) {
          rows.forEach(row => {
            // this.$refs.table.toggleRowSelection(row)
            this.$refs['ybl-table'].toggleRowSelection(row)
          })
        } else {
          this.clearSelection()
        }
      })
    },
    getTableRef () {
      return this.$refs['ybl-table']
    }
  },
  watch: {
    sceneIndex: function (newVal, oldVal) {
      // setTimeout(() => {
      //   this.getTableHeight(newVal)
      // }, 500)
      // this.getTableHeight(newVal)
    },
    dataLength: function (n, o) {
      // if (!o) this.upKey++

      this.$nextTick(() => {
        this.resize()
        this.$refs['ybl-table'].doLayout()
      })
    },
    current: function (newVal, oldVal) {
      newVal && (this.currentPage = newVal)
    }
  }
}
</script>
<style lang="less" scoped>
@import "../assets/less/color.less";
.ybl-table-list {
  // flex: 1 1 auto;
  box-sizing: border-box;
  width: 100%;
  // min-height: 200px;
  display: flex;
  flex-direction: column;
  padding: 17px 9px 50px;
  // padding-bottom: 60px;
  // overflow: hidden;
  // position: relative;
  position: revert;
  .nowrap {
    /deep/.el-table__header {
      th .cell {
        white-space: nowrap;
        font-weight: initial;
      }
    }
  }
  .default {
    line-height: 16px;
    display: flex;
    flex-direction: column;
    text-align: center;
    .default-img {
      width: 44px;
      height: 44px;
      display: inline-block;
      margin: 0 auto;
    }
    .default-placeholder {
      color: @minor-color;
      font-size: 12px;
      margin-top: 15px;
      display: inline-block;
    }
    .default-btn {
      display: inline-block;
      width: 56px;
      margin: 0 auto;
      margin-top: 42px;
    }
    .default-introduce {
      margin-top: 60px;
    }
  }
  &__footer {
    position: absolute;
    bottom: 0;
    z-index: 1000;
    width: calc(100% - 24px);
  }
  &__summary {
    display: flex;
    align-items: center;
    background-color: @secondary-border-color;
    font-size: 12px;
    color: @routine-color;
    border: 1px solid @summary-border-color;
    border-top: 0;
    height: 36px;
    // line-height: 36px;
    &__label {
      width: 54px;
      border-right: 1px solid #e2e5eb;
      text-align: center;
      margin-right: 18px;
    }
  }
  &__page {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px;
    box-sizing: border-box;
    /* position: absolute; */
    /* width: calc(100% - 24px); */
    // margin-bottom: 10px;
    // height: 32px;
    height: 50px;
    /* bottom: 0px; */
    // right: 12px;
    background-color: #fff;
    z-index: 9;
    border: 1px solid @summary-border-color;
    .el-pagination {
      font-weight: normal;
    }
    // box-shadow: 0px 1px 4px 0px rgba(204, 204, 204, 0.5),
    //   0px -1px 4px 0px rgba(204, 204, 204, 0.5);
    .batch-content {
      font-size: 12px;
      color: @routine-color;
      display: flex;
      align-items: center;
      justify-content: space-between;
      &_left {
        display: flex;
        align-items: center;
        .el-divider--vertical {
          margin-left: 23px;
          margin-right: 23px;
        }
        span + span {
          margin-left: 12px;
        }
      }
      .batch-button {
        display: flex;
        align-items: center;
        justify-content: space-between;
        &_label {
          margin-right: 18px;
        }
      }
    }
  }
  /deep/&_pager {
    .el-pagination__total {
      color: @routine-color;
    }
    .el-pagination__jump {
      color: @routine-color;
    }
  }
  /deep/.el-table {
    flex: 1;
  }
  /deep/.table-header__cell {
    background-color: @secondary-border-color;
    font-size: 12px;
    line-height: 12px;
    color: #666;
    font-family: Microsoft YaHei;
    height: 48px;
    font-weight: 500;
    .el-table__cell {
      border-color: #e2e5eb;
    }
  }
  /deep/.table-row__cell {
    height: 36px;
    // padding: 0 8px;
    line-height: 36px;
    box-sizing: border-box;
    overflow: hidden;
  }
  /deep/.el-table--small .el-table__cell {
    padding: 6px 0;
    .el-button--text {
      padding-top: 5px;
      padding-bottom: 5px;
    }
  }
  /deep/.el-progress__text {
    margin-left: 6px;
  }
  /deep/.el-table-column--selection .cell {
    padding-right: 10px;
  }
  /deep/.delete-button {
    color: #f80202;
    border-color: #f80202;
    &.el-button.is-plain:focus,
    &.el-button.is-plain:hover {
      color: #f80202;
      border-color: #f80202;
    }
  }
  .setting {
    position: absolute;
    right: 144px;
    // top: 18px;
    top: 0px;
    width: 32px;
    height: 48px;
    background-color: @secondary-border-color;
    // border: 1px solid #e2e5eb;
    z-index: 9;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #9b9c9e;
    i {
      padding: 10px 5px;
      cursor: pointer;
    }
    &.noOperate {
      right: 12px;
    }
  }
  /deep/.icon-primary {
    color: @color;
    font-size: 16px;
    cursor: pointer;
  }
  /deep/.icon-caution {
    color: @danger-color;
    font-size: 16px;
    cursor: pointer;
  }
  /deep/.iconfont + .iconfont {
    margin-left: 18px;
  }
  /deep/.el-table__empty-block {
    width: 100%;
    max-width: 100%;
    min-width: 100%;
    min-height: 200px;
    position: sticky;
    left: 0;
    top: 0;
  }
  /deep/.summary-info {
    padding: 5px 0;
    &__block {
      display: inline-block;
      padding-right: 10px;
    }
    &__value {
      color: #ff9033;
    }
  }
  /deep/.summary-info {
    padding: 5px 0;
    &__block {
      display: inline-block;
      padding-right: 10px;
    }
    &__value {
      color: #ff9033;
    }
  }
  /deep/.el-table__body tr.hover-row > td.el-table__cell {
    background-color: @table-hoverrow-color !important;
  }
  // /deep/.el-table::before {
  //   height: 0;
  // }
  .paddingEmpty {
    padding: 6px;
  }
  /deep/.el-table__body-wrapper {
    // min-height: 200px;
    position: unset;
  }
  // /deep/.el-table__append-wrapper{
  //   position: absolute;
  //   top: 0;
  //   right: 140px;
  //   z-index: 9;
  // }
}
.position-box {
  width: 35px;
}
.setting-box {
  width: 35px;
  height: 50px;
  background-color: #000000;
}
</style>



// WEBPACK FOOTER //
// src/components/tableList.vue